import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectCurrentModulesState,
  toggleModuleExpandCollapse,
} from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';

const useExpandableModule = ({ moduleId }: { moduleId: string }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(true);

  const modulesStates = useSelector(selectCurrentModulesState);

  useEffect(() => {
    if (!modulesStates || !Object.keys(modulesStates).length) {
      return;
    }
    const moduleState = modulesStates[moduleId];
    if (moduleState) {
      setIsOpen(moduleState.isOpen);
    }
  }, [modulesStates, setIsOpen, moduleId]);

  return {
    isOpen,
    toggle: () => dispatch(toggleModuleExpandCollapse({ moduleId })),
  };
};

export default useExpandableModule;
